import React, { Component } from 'react'
import './Login.css'
import Row from 'react-bootstrap/Row'
import Container from 'react-bootstrap/Container'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import {authProvider} from '../firebase'


class Login extends Component{
    state = {
        email: '',
        password: '',
        message: null,
        err: false
    }
    signIn = (email, password) => {
        console.log('inside')
        authProvider.signInWithEmailAndPassword(email, password).catch((err) => {
            console.log(err)
            this.setState({err : true, message: 'email/password is incorrect'})
        }).then(() => {
            this.props.history.push('/')
        })
    }
    handleChange = (evt) => {
        this.setState({
            [evt.target.name] : evt.target.value
        })
    }
    handleSubmit = (evt) => {
        evt.preventDefault()
        console.log('clicked')
        this.signIn(this.state.email, this.state.password)
    }
    signUp = () => {
        this.props.history.push('/signup')
    }
    render() {
        return (
            <Container>
                <Row className="Signup-bottom Signup-head">
                    <Col xs={1} md={3}>
                    </Col>
                    <Col xs={10} md={6}>
                        <Row className="Signup-bg">
                            <Col>
                                <Row className="Signup-bottom">
                                    <Col className="Signup-title d-flex justify-content-center">
                                        Login
                                    </Col>
                                </Row>
                                <Form onSubmit={this.handleSubmit}>
                                    <Row>
                                        <Col>
                                            <Form.Group controlId="email">
                                                <Form.Label>Email Address</Form.Label>
                                                <Form.Control type="email" name='email' value={this.state.email} placeholder="Enter email address" onChange={this.handleChange} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group controlId="password">
                                                <Form.Label>password</Form.Label>
                                                <Form.Control type="password" name='password' value={this.state.password} placeholder="enter a password" onChange={this.handleChange} />
                                                <Form.Text className="text-muted d-flex justify-content-center">
                                                    <span className={this.state.err ? "Signup-message-error" : "Signup-message"}>{this.state.message}</span>
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="Signup-button">
                                        <Col className="d-flex justify-content-center">
                                            <Button type="submit">Submit</Button>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="Login-signup d-flex justify-content-center">
                                            <span>or register <span onClick={this.signUp} className="Login-signuptext">here</span></span>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default Login

                                    